import type { paths } from '../Types/api';

export type ProductSearchHit = paths['/api/Order/Search']['get']['responses'][200]['content']['application/json'][number];

const normalize = (value: string | null | undefined): string => (value ?? '').toLocaleLowerCase('sv');

export const filterProducts = (products: ProductSearchHit[], query: string): ProductSearchHit[] => {
    const term = normalize(query.trim());
    if (!term) {
        return [];
    }

    return products.filter((product) => normalize(product.description).includes(term) || normalize(product.productNumber).includes(term));
};

export const mergeProductResults = (...lists: ProductSearchHit[][]): ProductSearchHit[] =>
    lists.flat().sort((a, b) => (a.description ?? '').localeCompare(b.description ?? '', 'sv') || (a.productNumber ?? '').localeCompare(b.productNumber ?? '', 'sv'));
